// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","miniLogo":"Logo_miniLogo__5RSbB"};